import { IconProps } from '../icon';

export function FichierPDFIcon(props: IconProps) {
  return (
    <svg
      height="76"
      viewBox="0 0 58 76"
      width="58"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="translate(-392.955 -102.727)">
        <path
          d="m412.75 104.227h36.7v73h-55v-54.549z"
          fill="#fff"
          stroke="#969696"
          strokeMiterlimit="10"
          strokeWidth="3"
        />
        <path d="m398.455 156.227h46v16h-46z" fill="#969696" />
        <text
          fill="#fff"
          fontFamily="MyriadPro-Regular, Myriad Pro"
          fontSize="9"
          transform="translate(398.455 159.606)"
        >
          <tspan x="15.418" y="7">
            PDF
          </tspan>
        </text>
        <g stroke="#969696" strokeMiterlimit="10" strokeWidth="3">
          <path d="m420.5 114.5h-15" fill="none" />
          <path d="m420.424 121.033h-15" fill="none" />
          <path d="m420.5 127.033h-21.076" fill="none" />
          <path d="m441.5 133.033h-42.115" fill="none" />
          <path d="m441.981 139.033h-42.115" fill="none" />
          <path d="m441.981 146.033h-42.115" fill="none" />
          <path d="m441.981 152.033h-42.115" fill="none" />
          <path d="m412.955 105.227v17.5h-17.5" fill="#fff" />
        </g>
        <path d="m423.5 111.5h18v18h-18z" fill="#969696" />
      </g>
    </svg>
  );
}

export default FichierPDFIcon;
